import React, { useMemo } from 'react';
import {
	AccessorKeyColumnDef,
	CellContext,
	createColumnHelper,
	RowData,
} from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import Table from './Table';

export type EstablishmentDataEntry = {
	id: number;
	name: string;
};

type DeleteCellProps = CellContext<EstablishmentDataEntry, unknown> & {
	onClick: (row: RowData) => void;
};
const DeleteCell = ({ row, onClick }: DeleteCellProps) => {
	return (
		<div className="text-end">
			<span
				className="text-center glyphicons glyphicons-bin clickable b-left d-inline-block p-0 chip-glyphicon cursor-pointer"
				id={`remove-user-${row.original.id}`}
				onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
					onClick(row.original);
				}}
			/>
		</div>
	);
};

const columnHelper = createColumnHelper<EstablishmentDataEntry>();

type Props = {
	establishments: EstablishmentDataEntry[];
	handleDelete: (row: RowData) => void;
	handleRowClick: (row: RowData) => void;
};

const EstablishmentOverview = ({ establishments, handleDelete, handleRowClick }: Props) => {
	const { t } = useTranslation();

	const columns = useMemo(() => {
		return [
			columnHelper.accessor('name', {
				header: t('establishments.establishment'),
			}),
			columnHelper.display({
				id: 'delete',
				cell: (cellInfo) => <DeleteCell {...cellInfo} onClick={handleDelete} />,
			}),
		] as Array<AccessorKeyColumnDef<EstablishmentDataEntry, unknown>>;
	}, []);

	return <Table data={establishments} columns={columns} handleRowClick={handleRowClick} />;
};

export default EstablishmentOverview;
